import React from 'react';
import {
  Grid,
} from '@mui/material';
import {makeStyles} from "@mui/styles";

import "react-datepicker/dist/react-datepicker.css";
import { addCommaToEvery3Digits } from "../../lib";
const useStyles = makeStyles(() => ({
  box:{
    marginLeft: 32,
    width: 256,
    height: 112,
  },
  container:{
    paddingLeft: 32,
    paddingTop: 24
  },
  imgBackground:{
    width: 60,
    height: 60,
    borderRadius: 6,
    textAlign: "center"
  },
  colorGreen:{
    backgroundColor: "green"
  },
  colorRed:{
    backgroundColor: "red"
  },
  colorPurple:{
    backgroundColor: "purple"
  },
  img:{
    marginTop: 20
  },
  contents: {
    marginLeft: 32
  },
  count: {
    marginTop: 6,
    fontSize: 20,
    fontWeight: "bold",
    fontFamily: "NotoSansKR",
    color: "#282d30"
  },
  text: {
    fontSize: 14,
    fontFamily: "NotoSansKR",
    fontWeight: 500,
    color: "#74798c"
  }
}));



export default function TodayBox(props: any){
  const classes = useStyles();
  const { text, count, image, color } = props;
  const convertCount = addCommaToEvery3Digits(parseInt(count));
  return(
   <div className={classes.container}>
     <Grid container>
       <Grid>
        <div className={classes.imgBackground} style={{backgroundColor:color}}>
         <img src={process.env.PUBLIC_URL + "/static/images/" + image} className={classes.img} alt={''} />
        </div>
       </Grid>
       <Grid>
         <Grid container direction={"column"} className={classes.contents}>
           <Grid><div className={classes.count}>{convertCount}</div></Grid>
           <Grid><div className={classes.text}>{text}</div></Grid> {/*Body 활용*/}
         </Grid>
       </Grid>
     </Grid>
   </div>
  )
}